module.exports = __webpack_public_path__ + "img/bg_avatar_male_95.21927127.png";